import React, { Component } from 'react';
import { withSnackbar } from 'notistack';
import { compose } from 'redux';
import { DialogContent, FormHelperText } from '@mui/material';
import { PubSub } from '../../utils/eventUtils';

import { deleteNaicsCode } from '../../naics/NaicsService';
import { withToggleModal } from '../hocs/withToggleModal';

class NaicsCodeDeleteConfirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      naicsCode: '',
      error: '',
    };
  }

  componentDidMount() {
    const {
      props: { data },
    } = this;

    this.setState({
      id: data.id,
      naicsCode: data.naicsCode,
    });
    this.subscription = PubSub.subscribe('foot-button-one', (eventData) => {
      if (eventData) {
        this.handleSubmit();
      }
    });
  }

  handleSubmit = () => {
    PubSub.publish('loading', true);
    PubSub.publish('disabled', true);
    deleteNaicsCode({
      id: this.state.id,
    })
      .then(() => {
        PubSub.publish('loading', false);
        PubSub.publish('disabled', false);
        this.props.toggleModal.direct('NaicsCodeDeleteConfirm', false);
        this.props.enqueueSnackbar('Industry Code Deleted Successfully!', {
          variant: 'success',
        });
        PubSub.publish('table-refetch', 'naicsCodes');
      })
      .catch((error) => {
        PubSub.publish('loading', false);
        PubSub.publish('disabled', false);
        this.setState({ error: error.response.data });
      });
  };

  render() {
    return (
      <DialogContent>
        <div className="modal-title">
          You are about to remove the Industry Code -
          <span className="modal-blue-text"> {this.state.naicsCode}</span>.
          <p style={{ margin: 0 }}>Are you sure you want to delete it?</p>
        </div>
        <FormHelperText className="api-text-error">
          {this.state.error}
        </FormHelperText>
      </DialogContent>
    );
  }
}

export default compose(withSnackbar, withToggleModal)(NaicsCodeDeleteConfirm);
